import { render, staticRenderFns } from "./ForexCurrencyLimitsEditorModal.vue?vue&type=template&id=2af10f56"
import script from "./ForexCurrencyLimitsEditorModal.vue?vue&type=script&lang=js"
export * from "./ForexCurrencyLimitsEditorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports